// extracted by mini-css-extract-plugin
export default {"wrapper":"p98_E","title":"GJTkW","questions":"uaJA8","item":"O8cyl","question":"ScDRy","answer":"YEPYs","opened":"WO059","hidden":"YLaIt"};